import { render, staticRenderFns } from "./notarizationApply.vue?vue&type=template&id=23c108fb&scoped=true"
import script from "./notarizationApply.vue?vue&type=script&lang=js"
export * from "./notarizationApply.vue?vue&type=script&lang=js"
import style0 from "./notarizationApply.vue?vue&type=style&index=0&id=23c108fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c108fb",
  null
  
)

export default component.exports